/* eslint-disable */

import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import HeaderGrid from '../../Pagination/HeaderGrid'
import http from '../../Interceptor/Interseptor'
import BASE_MANAGE from '../../BaseComponent/BASEMANAGE'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'

import $ from 'jquery'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {message} from 'antd'
import '../../../style/payment-base.css'
import Sort from '../../Pagination/Sort'
import Pageing from '../../Pagination/pageing'

class Terminal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      pageSize: 10,
      pageNumber: 1,
      lengthTerminal: 0,
      sortBy: 'id_desc',
      getSort: '',
      terminals: [],
      modalDelete: false,
      deleteId: 0,
      modalEdit: false,
      editId: 0,
      editName: '',
      excelReport: [],
      sortData: [
        {
          name: 'External Id',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'کد ترمینال',
          value: 'code',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'برند',
          value: 'brand',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'شماره سریال',
          value: 'serialNumber',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'روش پرداخت',
          value: 'typeAccountName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'راننده',
          value: 'assigneeName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'ویرایش',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'حذف',
          value: 'delete',
          sorted: false,
          direction: null,
          sortable: false
        }
      ]
    }
  }
  componentDidMount() {
    this.getterminals()
  }

  getterminals = () => {
    let data = {
      pageSize: this.state.pageSize,
      pageNumber: this.state.pageNumber,
      sortBy: this.state.sortBy,
      export: false
    }

    http
      .get(`${BASE_MANAGE.BASE_MANAGE_PAYMENT_GET_LIST_TERMINAL}`, {
        params: data
      })
      .then((res) => {
        if (res.data.error === null) {
          $('.showBaseTable').fadeIn()
          this.setState({
            terminals: res.data.object.result,
            lengthTerminal: res.data.object.countAll
          })
        } else {
          $('.showBaseTable').fadeOut()
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  delete = (numId) => {
    this.setState({
      modalDelete: !this.state.modalDelete,
      deleteId: numId
    })
  }
  deleteOk = () => {
    let id = this.state.deleteId

    http
      .delete(`${BASE_MANAGE.BASE_MANAGE_PAYMENT_DELETE_TERMINAL}/${id}`, {})
      .then((response) => {
        if (response.data.error == null) {
          message.success('ترمینال با موفقیت حذف شد')
          this.setState({
            modalDelete: !this.state.modalDelete,
            deleteId: 0
          })
          this.getterminals()
        } else {
          message.error(JSON.stringify('خطای ' + response.data.errorCode + ' : ' + response.data.description))
          this.setState({
            modalDelete: !this.state.modalDelete,
            deleteId: 0
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })
  }

  deleteCancel = () => {
    this.setState({
      modalDelete: !this.state.modalDelete
    })
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }
  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getterminals()
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getterminals()
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getterminals()
    }
  }

  exportExcel = () => {
    let data = {
      pageSize: this.state.pageSize,
      pageNumber: this.state.pageNumber,
      sortBy: this.state.sortBy,
      export: true
    }

    http
      .get(`${BASE_MANAGE.BASE_MANAGE_PAYMENT_GET_LIST_TERMINAL}`, {
        params: data
      })
      .then((res) => {
        if (res.data.error === null) {
          this.setState({
            excelReport: res.data.object.result
          })
          this._export.save(this.state.excelReport)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  render() {
    let {terminals, pageSize, pageNumber} = this.state
    return (
      <div className="rtl ">
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="ترمینال ها.xlsx"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'ID'}
                field={'typeAccountId'}
                title={'ID'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'code'}
                field={'code'}
                title={'کد ترمینال'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'brand'}
                field={'brand'}
                title={'برند'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'serialNumber'}
                field={'serialNumber'}
                title={'شماره سریال'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'typeAccountName'}
                field={'typeAccountName'}
                title={'روش پرداخت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'assigneeName'}
                field={'assigneeName'}
                title={'راننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>پرداخت</li>
            <li>پایانه ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={'/addterminal'} enablePageSize />
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
              </div>
              {/*<button className='add-butt' >*/}
              {/*    <Link style={{"color":"white"}} to={"/addterminal"}  > افزودن </Link>*/}
              {/*</button>*/}
            </div>
            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />
                  {terminals.map((terminal, index) => (
                    <tr key={index}>
                      <td>{terminal.externalId}</td>
                      <td>{terminal.code}</td>
                      <td>{terminal.brand}</td>
                      <td>{terminal.serialNumber}</td>
                      <td>{terminal.typeAccountName}</td>
                      <td>{terminal.assigneeName}</td>
                      <td>
                        <Link to={`/editterminal/${terminal.terminalId}`}>
                          <img src={require('../../../image/editDriver.svg')} alt={'edit'} />
                        </Link>
                      </td>
                      <td>
                        <button onClick={() => this.delete(terminal.terminalId)}>
                          <img src={require('../../../image/trash.svg')} alt={'trash'} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={pageSize}
                  currentPage={pageNumber}
                  total={this.state.lengthTerminal}
                />
              </div>
            </div>
          </div>

          <Modal isOpen={this.state.modalDelete} toggle={this.toggleCancel} size="sm">
            <ModalHeader toggle={this.toggleCancel}>حذف بانک</ModalHeader>
            <ModalBody>
              <p className="titleSm">آیا از حذف ترمینال مطمئن هستید؟؟؟</p>
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.deleteOk}>
                حذف ترمینال
              </button>
              <button className="cancelBtnModal" onClick={this.deleteCancel}>
                لغو
              </button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}

export default Terminal
